import { Box, Stack } from "@mui/joy";
import Sheet from "@mui/joy/Sheet";
import { LogoWithTextSvg } from "static/image/common/SvgAssets";
import useIsInappWebview from "hooks/useIsInappWebview";
import useSubscriptionStatus from "hooks/useSubscriptionStatus";
import React from "react";
import PaymentModule from "./PaymentModule";
import HomeTaskListForPatient from "components/task-list/HomeTaskListForPatient";
import MyPageModule from "./MyPageModule";
import { theme } from "styles/theme";
import useIsTabExists from "../../hooks/useIsTabExists";
import NoticeBanner from "components/common/NoticeBanner";
import { useRecoilValue } from "recoil";
import { userAtom } from "../../recoil/userAtom";
import PlanUpgradeModule from "./PlanUpgradeModule";

export type SidebarMenuType = "patient" | "task";

export default function SidebarForPatient({ isHome }: { isHome?: boolean }) {
  const isInappWebview = useIsInappWebview();
  const { isExpired } = useSubscriptionStatus();
  const isTabExists = useIsTabExists();
  const user = useRecoilValue(userAtom);

  const backgroundColor = isInappWebview
    ? theme.vars.palette.Background.Level1
    : theme.vars.palette.Background.Level2;

  return (
    <Sheet>
      <Sheet
        className="Sidebar"
        sx={{
          position: !isHome && isInappWebview ? "fixed" : "sticky",

          transform:
            !isHome && isInappWebview ? "translateX(-100%)" : "translateX(0)",
          transition: "transform 0.4s, width 0.4s",
          width: "var(--Sidebar-width)",

          // paddingBottom: `${20}px`,
          height: "100%",
          top: 0,
          flexShrink: 0,
          display: "flex",
          flexDirection: "column",
          backgroundColor: backgroundColor,
          overflow: "hidden",
        }}
      >
        <Stack
          sx={
            {
              // backgroundColor: "white",
              // borderBottomWidth: "1px",
              // borderColor: "divider",
            }
          }
        >
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
            sx={{
              px: "20px",
              height: "var(--StickyHeader-height)",
              minHeight: "var(--StickyHeader-height)",
            }}
          >
            <LogoWithTextSvg />
          </Stack>
          <NoticeBanner />
        </Stack>

        <Stack
          direction={"row"}
          sx={{
            width: "200%",
            minHeight: 0,
            height: "100%",
          }}
        >
          <Box
            sx={{
              width: "var(--Sidebar-width)",
              px: "20px",
              pb: 10,
              minHeight: 0,
              height: "100%",
              overflow: "hidden auto",
            }}
          ></Box>

          <Box
            sx={{
              width: "var(--Sidebar-width)",
              pb: 10,
              minHeight: 0,
              height: "100%",
              overflow: "hidden auto",
              transform: "translateX(-100%)",
              transition: "transform 0.4s, width 0.4s",
              backgroundColor: backgroundColor,
              zIndex: 10,
            }}
            className="scrollbar-hide"
          >
            <HomeTaskListForPatient />
            {!isTabExists && (
              <Box sx={{}}>
                <MyPageModule />
              </Box>
            )}
          </Box>
        </Stack>
        {isExpired ? (
          <Box>
            <Box
              sx={{
                position: "relative",
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  top: "-12px",
                  zIndex: 10,
                  left: 0,
                  width: "100%",
                  height: "12px",
                }}
              />
              <PaymentModule type="footer" />
            </Box>
          </Box>
        ) : user?.plan ? (
          <PlanUpgradeModule currentPlan={user?.plan!!} />
        ) : (
          <></>
        )}
      </Sheet>
    </Sheet>
  );
}
